import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LongRunningTask } from 'components/systemTasks/SystemTask';
import { isNullOrUndefined } from 'utils/Global';

export type systemTaskState = {
  tasks: LongRunningTask[];
};

const initialState = { tasks: [] } as systemTaskState;

const systemTaskSlice = createSlice({
  name: 'systemTask',
  initialState,
  reducers: {
    addTask: (state, action: PayloadAction<LongRunningTask>): void => {
      state.tasks.push(action.payload);
    },
    removeTask: (state, action: PayloadAction<number>): void => {
      state.tasks = state.tasks.filter((t) => t.id !== action.payload);
    },
    updateProgress: (
      state,
      action: PayloadAction<{ taskId: number; progress?: number; title?: string }>,
    ): void => {
      const task = state.tasks.find((t) => t.id === action.payload.taskId);
      if (!isNullOrUndefined(task)) {
        if (action.payload.progress) {
          task.progress = Math.ceil(action.payload.progress);
        }
        if (action.payload.title) {
          task.title = action.payload.title;
        }
      }
    },
    removeCompletedTask: (state): void => {
      state.tasks = state.tasks.filter((t) => t.progress != 100);
    },
    removeAllTasks: (state): void => {
      state.tasks = [];
    },
  },
});

export const {
  addTask,
  removeTask,
  updateProgress,
  removeCompletedTask,
  removeAllTasks,
} = systemTaskSlice.actions;

export default systemTaskSlice.reducer;
